module.exports = new __parcel__URL__("basic-phrases.66bd453a.mp4").toString();